import { ReactNode, memo } from 'react';
import { ContentNode } from '@amzn/awscat-pattern-library-service-model';

import { sectionScrollTargetIdForNode } from './ContentNodeExtensions';
import styles from './SectionScrollTarget.module.scss';

interface SectionScrollTargetProps {
  /** Section this wrapper is the scroll destination for. */
  readonly node: ContentNode;
  /** Section content rendered inside the scroll target. */
  readonly children: ReactNode;
}

/**
 * Wraps a Pattern section so the navigator can scroll it into view. Emits the
 * DOM id that {@link sectionScrollTargetIdForNode} looks up and offsets the
 * scroll position below the fixed APG header.
 */
const SectionScrollTarget = memo(function SectionScrollTarget({
  node,
  children,
}: SectionScrollTargetProps) {
  return (
    <div id={sectionScrollTargetIdForNode(node)} className={styles.sectionScrollTarget}>
      {children}
    </div>
  );
});

export { SectionScrollTarget };
